import React from "react";
import SelectMenu from "../../controls/SelectMenu";
import Input from "../../controls/Input";
import DatePickerInput from "../../controls/DatePickerInput";

const fieldClassName =
  "mt-1.5 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm shadow-sm placeholder:text-slate-400 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30";

export default function SunDistributionDetailsSection(props: any) {
  const { values, errors, handleInputChange, customers, showHeader = true } =
    props;

  return (
    <div className="w-full max-w-xl space-y-5">
      {showHeader ? (
        <div>
          <h3 className="text-base font-semibold text-slate-900">
            Order details
          </h3>
          <p className="mt-1 text-sm text-slate-500">
            Customer, PO, and order date
          </p>
        </div>
      ) : null}

      <div className="space-y-4">
        <SelectMenu
          handleInputChange={handleInputChange}
          name="customer"
          options={customers}
          value={values.customer}
          title="Customer *"
          error={errors.customer}
          showLabel={true}
          parentClass="w-full"
        />

        <Input
          label="PO # *"
          name="po_number"
          onChange={handleInputChange}
          value={values.po_number}
          labelOn={true}
          type="text"
          error={errors.po_number}
          className={fieldClassName}
        />

        <DatePickerInput
          label="Order Date *"
          name="order_date"
          onChange={handleInputChange}
          value={values.order_date}
          labelOn={true}
          minDate={new Date()}
          dateFormat="LLL dd, yyyy"
          type="text"
          className={fieldClassName}
          error={errors.order_date}
        />
      </div>
    </div>
  );
}
